import React, { useEffect } from "react";

import { QueryStateIndicator } from "@components/QueryStateIndicator";
import { withPermissions } from "@components/withPermissions";
import {
  useGetBpMobileAppSettings,
  usePutBpMobileAppSettings
} from "@libs/api/gateways/bp-mobile/bp-mobile.hooks";
import { Permissions } from "@libs/permissions/permissions.enum";

import {
  BpMobileMaintenanceForm,
  BpMobileMaintenanceFormSubmitValues
} from "./BpMobileMaintenanceAppForm";
import { useFeedbackContext } from "../../../../libs/stores/feedback-context/feedback-context";
import { UseFormMethods } from "@bps/fluent-ui";

const BpMobileAppBase: React.FC = () => {
  const {
    data: settings,
    isLoading: isLoadingSettings
  } = useGetBpMobileAppSettings();

  const updateMutation = usePutBpMobileAppSettings();

  const { success } = useFeedbackContext();

  // Effect to handle success feedback
  useEffect(() => {
    if (updateMutation.isSuccess) {
      success("Settings updated successfully!");
    }
  }, [success, updateMutation.isSuccess]);

  const onSubmit = async (
    values: BpMobileMaintenanceFormSubmitValues,
    actions: Pick<
      UseFormMethods<BpMobileMaintenanceFormSubmitValues>,
      "reset" | "setValue"
    >
  ) => {
    updateMutation.mutate(values);
    actions.reset(values);
  };

  return (
    <QueryStateIndicator
      isLoading={isLoadingSettings}
      data={settings}
      noDataText="No settings available"
      allowNullOrUndefined={true}
    >
      {settings => (
        <BpMobileMaintenanceForm onSubmit={onSubmit} settings={settings} />
      )}
    </QueryStateIndicator>
  );
};

export const BpMobileApp = withPermissions(
  BpMobileAppBase,
  [Permissions.BhMobileSettingsRead, Permissions.BhMobileSettingsWrite],
  "or"
);
